<template>
  <div>
    <van-nav-bar style="background-color: #42b983">
      <template #title>
        <span style="color: #ffffff">我的订单</span>
      </template>
      <template #left>
        <router-link to="/my">
          <van-icon name="arrow-left" color="#ffffff"/>
          <span style="color: #ffffff">返回</span>
        </router-link>
      </template>
      <template #right>
        <router-link to="/">
          <van-icon name="wap-home-o" color="#ffffff" size="1.3rem"/>
        </router-link>
      </template>
    </van-nav-bar>

    <van-list
        v-model="loading"
        :finished="finished"
        :error.sync="error"
        :error-text="error_text"
        finished-text="没有更多了"
        @load="onLoad(false)"
    >
      <van-collapse v-model="listActive">

        <van-cell v-for="order in orders" :key="order.id">
          <template #title>
            <span class="custom-title">{{ order.product.title }}</span>
            <van-button type="info" size="mini" v-if="0===order.status" @click="payConfirm(order.order_no)">手动确认</van-button>
          </template>
          <template #label>
            <div style="width: 100%">
              科目:{{ order.subject.name }}<br>
              金额:{{ order.total_amount }}元<br>
              充值时间:{{ order.created_at }}<br>
              支付时间:{{ order.pay_time }}<br>
              <span style="font-size: 0.1em">{{ order.order_no }}</span><br>
            </div>
          </template>
          <template #default>
            <van-tag v-if="0===order.status" type="danger" @click="payConfirm(order.order_no)">未支付</van-tag>
            <van-tag v-else type="success">已支付</van-tag>
          </template>
        </van-cell>




      </van-collapse>
    </van-list>



  </div>
</template>

<script>
export default {
  data() {
    return {
      page: 1,
      listTotal: 0,
      listActive: [],

      changeSearchModel: false,

      loading: false,
      finished: false,
      error: false,
      error_text: "",

      orders: [],

    };
  },
  created() {

  },
  methods: {
    onLoad(isNew) {
      if (isNew) {
        this.orders = [];
        this.page = 1;
        this.finished = false;
      }
      this.loading = true;
      this.$http.get("/wechat/user/orders", {
        params: {
          pre_page: 8,
          page: this.page,
        }
      }).then(res => {
        this.loading = false;
        if (200 !== res.data.code) {
          this.error = true
          this.error_text = res.data.msg
          return
        }
        if (!res.data.data || res.data.data.length <= 0 ) {
          this.finished = true
          return;
        }
        this.page++

        this.listTotal = res.data.meta.total
        this.orders = this.orders.concat(res.data.data);
      });
    },
    payConfirm(order_no) {
      this.$http.get("/wechat/admin/pay_confirm", {
        params: {
          order_no: order_no,
        }
      }).then(res => {
        console.log(res.data);
        if (200 !== res.data.code) {
          this.$toast.fail(res.data.msg);
          return
        }
        this.$toast.success(res.data.msg);
      });
    },
  }
}
</script>
